import React from 'react'
import Skeleton from 'antd/lib/skeleton'

const ProfilePictureLoading: React.FC = () => {
  return (
    <Skeleton.Image
      style={{
        width: 175,
        height: 220,
        borderRadius: 16
      }}
    />
  )
}

export default ProfilePictureLoading
